import { useEffect, useRef } from "react";

/**
 * Hook to create a React Portal.
 * @param selector - The query selector of the target
 */
export function usePortal(target: string): HTMLElement | null {
    const containerEl = useRef(document.createElement("div"));

    useEffect(
        function setupElement() {
            const elem = containerEl.current;
            // Look for existing target dom element to append to
            const parentElem = document.querySelector(target);
            // Add the detached element to the parent
            parentElem?.appendChild(elem);
            // This function is run on unmount
            return function removeElement(): void {
                parentElem?.removeChild(elem);
            };
        },
        [containerEl, target],
    );

    return containerEl.current;
}

export default usePortal;
